import React from 'react';
import StatusBadge from '@/components/ui/StatusBadge';
import { Cpu, ChevronRight } from 'lucide-react';

const jobs = [
  { id: 'job-001', rule: 'BGP-Session-Restart', node: 'CORE-NYC-01', triggered: 'AI Detection', status: 'success' as const, duration: '1m 12s', time: '09:23:55' },
  { id: 'job-002', rule: 'Interface-Flap-Dampen', node: 'EDGE-AMS-04', triggered: 'Threshold', status: 'running' as const, duration: '0m 47s', time: '09:24:01' },
  { id: 'job-003', rule: 'Traffic-Reroute-ECMP', node: 'EDGE-LAX-03', triggered: 'AI Detection', status: 'verifying' as const, duration: '2m 03s', time: '09:22:18' },
  { id: 'job-004', rule: 'OSPF-Neighbor-Reset', node: 'AGG-SIN-01', triggered: 'AI Detection', status: 'success' as const, duration: '0m 58s', time: '09:21:40' },
  { id: 'job-005', rule: 'CPU-Process-Kill', node: 'CORE-NYC-01', triggered: 'Threshold', status: 'failed' as const, duration: '0m 22s', time: '09:20:11' },
  { id: 'job-006', rule: 'Link-Failover-Activate', node: 'EDGE-MIA-02', triggered: 'AI Detection', status: 'success' as const, duration: '1m 34s', time: '09:18:05' },
  { id: 'job-007', rule: 'QoS-Policy-Reapply', node: 'AGG-CHI-02', triggered: 'Manual', status: 'queued' as const, duration: '-', time: '09:25:00' },
];

const statusMap: Record<string, 'success' | 'failed' | 'running' | 'verifying' | 'queued'> = {
  success: 'success',
  failed: 'failed',
  running: 'running',
  verifying: 'verifying',
  queued: 'queued',
};

export default function AutomationJobList() {
  return (
    <div className="bg-surface border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Cpu size={15} className="text-primary" />
          <p className="text-sm font-semibold text-foreground">Remediation Jobs</p>
          <span className="text-[10px] bg-primary/10 text-primary border border-primary/20 px-2 py-0.5 rounded-full font-mono">
            2 active
          </span>
        </div>
        <button className="text-[11px] text-primary hover:text-primary/80 transition-colors">
          View all →
        </button>
      </div>

      <div className="space-y-1">
        {jobs.map((job) => (
          <div
            key={job.id}
            className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-surface-raised transition-colors group cursor-pointer"
          >
            <StatusBadge status={statusMap[job.status]} />
            <div className="flex-1 min-w-0">
              <p className="text-[12px] font-medium text-foreground truncate">{job.rule}</p>
              <div className="flex items-center gap-1.5 mt-0.5">
                <span className="font-mono text-[10px] text-muted">{job.node}</span>
                <span className="text-muted text-[10px]">·</span>
                <span className="text-[10px] text-muted">{job.triggered}</span>
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <p className="font-mono text-[11px] text-foreground-muted">{job.duration}</p>
              <p className="font-mono text-[10px] text-muted">{job.time}</p>
            </div>
            <ChevronRight size={12} className="text-muted opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}